





































































































import Vue from 'vue'
import request from '@/utils/request'
const msgSet: any = {
    areaId: '',
    pre1h: 30,
    pre1hState: false,
    pre3h: 50,
    pre3hState: false,
    pre6h: 100,
    pre6hState: false,
    pre12h: 150,
    pre12hState: false,
    pre24h: 200,
    pre24hState: false,
    forecastState: false,
}
export default Vue.extend({
    computed: {
        current(): any {
            return this.$store.state.current
        },
        // managerInfo(): any {
        //     return this.$store.state.managerInfo
        // },
        // areaList(): any[] {
        //     console.log(this.$store.state.areaList)
        //     const arr = this.$store.state.areaList
        //     arr.map((e: any) => {
        //         e.checked = false
        //     })
        //     // return this.$store.state.areaList
        //     return arr
        // },
    },
    data() {
        return {
            loading: false,
            msgSet,
            areaList: [],
        }
    },
    watch: {
        msgSet: {
            handler() {
                if (this.loading) {return}
                this.postMsgSet()
            },
            deep: true,
        },
    },
    mounted() {
        this.areaList = JSON.parse(JSON.stringify(this.$store.state.areaList))
        this.areaList.map((e: any) => {
            e.checked = false
        })
        this.getMsgSet()
        // console.log(this.current)
        // console.log(this.managerInfo)
    },
    methods: {
        setAreaId(areaId: any) {
            // console.log(areaId)
            if (this.msgSet.areaId === areaId) {
                this.$dialog.confirm({ message: '您正在取消定制的区域，是否确认？'})
                .then(() => this.msgSet.areaId = '')
                .catch(() => console.log('cancel'))
            } else {
                if (areaId === '430527') {
                    this.msgSet.areaId = areaId
                    this.areaList.map((e: any) => {
                        this.$set(e, 'checked', false)
                    })
                } else {
                    const newArr = this.msgSet.areaId.split(',')
                    if (newArr.indexOf(areaId) > -1) {
                        this.$dialog.confirm({ message: '您正在取消定制的区域，是否确认？'})
                        .then(() => {
                            this.areaList.map((e: any) => {
                                if (areaId === e.id) {
                                    this.$set(e, 'checked', false)
                                }
                            })
                            const arr = []as any
                            this.areaList.map((e: any) => {
                                if (e.checked === true) {
                                    arr.push(e.id)
                                }
                            })
                            this.msgSet.areaId = arr.join(',')
                        })
                        .catch(() => console.log('cancel'))
                    } else {
                        this.areaList.map((e: any) => {
                            if (areaId === e.id) {
                                this.$set(e, 'checked', true)
                            }
                        })
                        const arr = []as any
                        this.areaList.map((e: any) => {
                            if (e.checked === true) {
                                arr.push(e.id)
                            }
                        })
                        this.msgSet.areaId = arr.join(',')
                    }
                }
            }
            // } else {
            //     this.areaList.map((e: any) => {
            //         this.$set(e, 'checked', false)
            //     })
            // }
            // console.log(this.areaList)
            // if (this.msgSet.areaId === areaId) {
            //     this.$dialog.confirm({ message: '您正在取消定制的区域，是否确认？'})
            //     .then(() => this.msgSet.areaId = '')
            //     .catch(() => console.log('cancel'))
            // } else {this.msgSet.areaId = areaId}
        },
        // 定制信息
        getMsgSet() {
            this.loading = true
            request.get('/api/farming/rest_msg_set/info').then((res: any) => {
                if (res) {
                    // console.log(res)
                    this.msgSet = res
                    if (this.msgSet.areaId === '430527') {
                        this.areaList.map((e: any) => {
                            this.$set(e, 'checked', false)
                        })
                    } else {
                        if (this.msgSet.areaId) {
                            const newArr = this.msgSet.areaId.split(',')
                            this.areaList.map((e: any) => {
                                newArr.map((i: any) => {
                                    if (e.id === i) {
                                        this.$set(e, 'checked', true)
                                    }
                                })
                            })
                        }
                    }
                    if (res.areaId !== this.$store.state.areaId) {
                        this.$store.commit('setAreaId', res.areaId) // 重置天气
                    }
                }
                setTimeout(() => this.loading = false, 90)
            }).catch((err) => {
                console.log(err)
                this.loading = false
            })
        },
        // 提交定制信息
        postMsgSet() {
            const { msgSet } = this
            request.post('/api/farming/rest_msg_set', msgSet).then(() => {
                this.$notify({ type: 'success', duration: 1000, message: '设置成功'})
                this.getMsgSet()
            })
        },
        getRole() {
            this.$router.push('/apply_role')
        },
    },
})
